<template>
  <div>
    <div class="top_tit">
      <div class="line"></div>
      <p>{{ deliver.Name }}</p>
    </div>
    <div class="bottom_content">
      <ul v-if="deliver.Deliveries.length > 0">
        <li
          v-for="d in deliver.Deliveries"
          :key="d.DeliveryId"
          @click="handelReadFile(d)"
        >
          <!-- DeliveryType:10视频    20音频   30图片   40文件   50文本 -->
          <div class="bottom_content_list">
            <img
              v-if="d.DeliveryType == '10'"
              height="100"
              src="../../../assets/images/shipin.png"
              width="300"
            />
            <img
              v-if="d.DeliveryType == '20'"
              height="100"
              src="@/assets/images/yinye.png"
              width="300"
            />
            <div
              v-if="
                d.DeliveryType == '30' ||
                d.DeliveryType == '40' ||
                d.DeliveryType == '50'
              "
              class="icon_box"
            >
              {{
                d.DeliveryName.split('.')[d.DeliveryName.split('.').length - 1]
              }}
            </div>
            <!-- <img
              v-if="d.DeliveryType == '30'"
              height="100"
              src="@/assets/images/jpg.png"
              width="300"
            />
            <img
              v-if="d.DeliveryType == '40' || d.DeliveryType == '50'"
              height="100"
              src="@/assets/images/pdf.png"
              width="300"
            /> -->
            <p>{{ d.DeliveryName }}</p>
          </div>
          <img
            alt=""
            class="arrowIcon"
            src="../../../assets/images/arrowright.svg"
          />
        </li>
      </ul>
      <!-- 暂无文本 -->
      <van-empty v-else description="暂无文件交付" image-size="40" />
    </div>
  </div>
  <ReadFile ref="ReadFile" :allow-download="true" />
</template>

<script>
  import { copyText } from '../../../utils/index'
  import ReadFile from '@/components/ReadFile'
  import api from '@/api'
  export default {
    name: 'DeliverCourse',
    components: {
      ReadFile,
    },
    props: {
      // eslint-disable-next-line vue/require-default-prop
      deliver: {
        type: Object,
      },
    },
    data() {
      return {
        url: 'http://file.test.com/88888/2022/04/21/1eab0b9e4d5c41dea73da4fce8fbbf44.zip',
      }
    },
    methods: {
      //排序
      sortBykey() {
        if (this.deliver) {
          return this.deliver.sort(function (a, b) {
            let x = a['Sort']
            let y = b['Sort']
            return x < y ? -1 : x > y ? 1 : 0
          })
        }
      },
      handelReadFile(item) {
        this.$refs['ReadFile'].readFile({
          MaterialType: 40,
          MaterialName: item.DeliveryName,
          MaterialUrl: item.DeliveryUrl,
        })
      },
      downloadFile(url) {
        const u = navigator.userAgent
        const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
        if (isAndroid) {
          // 安卓终端使用iframe
          window.open(api.FileHost + url)
        } else if (isiOS) {
          window.open(api.FileHost + url)
          // this.$dialog
          //   .alert({
          //     title: '请复制链接至浏览器下载',
          //     message: this.url,
          //     confirmButtonText: '复制',
          //   })
          //   .then(() => {
          //     copyText(this.url)
          //     console.log('dd :>> ')
          //   })
        } else {
          //1.如果是地址
          window.open(api.FileHost + url)
          // 2.如果是文件流
          // 浏览器
          // const aEle = document.createElement('a')
          // aEle.href = window.URL.createObjectURL(blob)
          // if (!filename) {
          //   // 没传文件名，就用后台的filename， 后台也没有传就。。。。
          //   filename = res.headers['content-disposition'].split('filename=')[1]
          //   filename = decodeURIComponent(filename || '')
          // }
          // aEle.download = filename
          // aEle.click()
          // window.URL.revokeObjectURL(aEle.href)
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .bottom_content {
    min-height: 70px;
    ul {
      li {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 16px;
        border-bottom: 1px solid #e4e5ea;
        padding-top: 16px;
        .arrowIcon {
          width: 24px;
        }
        .bottom_content_list {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          width: 90%;
          .icon_box {
            background-color: #454976;
            width: 28px;
            height: 28px;
            border-radius: 4px;
            display: flex;
            flex-direction: row;
            font-size: 12px;
            color: #fff;
            justify-content: center;
            align-items: center;
          }
          img {
            width: 28px;
            height: 28px;
          }
          p {
            font-size: 15px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            margin-left: 14px;
            width: 86%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      li:last-child {
        border-bottom: none;
      }
    }
  }
</style>
